import * as z from "zod";

/** The launch waitlist on the marketing site. Sales stay closed until the launch day. */
export const WAITLIST_PATH = "/api/waitlist";
/** The one browser origin that may call the waitlist cross-origin. */
export const WAITLIST_ORIGIN = "https://prea.ia.br";

export const WaitlistSignupInputSchema = z.object({
  email: z.string().trim().max(254).email(),
  name: z.string().trim().max(120).optional(),
  profession: z.string().trim().max(120).optional(),
  source: z.string().trim().max(64).optional(),
  /** Honeypot: people never see or fill it. A filled value is dropped without an error. */
  website: z.string().optional(),
});
export type WaitlistSignupInput = z.infer<typeof WaitlistSignupInputSchema>;
